module.exports = __webpack_public_path__ + "120f1bf24e3cc9f67b1b08ef6fbd2da1.png";